import { URL_PREFIX } from '../constants/api';

interface UserLookup {
  email: string;
  id: number;
  name: string;
}

export interface TrackOverwritePost {
  isrc: string;
  track_title?: string;
  artist_name?: string;
  comment?: string;
}

export interface TrackOverwriteRow {
  isrc: string;
  track_title: string;
  artist_name: string;
}

export interface TrackOverwrite {
  isrc: string;
  track_title: string;
  artist_name: string;
  comment: string;
  created_at: string;
  created_by: UserLookup;
  updated_at: string;
  updated_by: UserLookup;
}

export async function getTrackOverwrite(
  isrc: string,
): Promise<TrackOverwrite | null> {
  try {
    const resp = await fetch(`${URL_PREFIX}/api/v1/overwrites/${isrc}`);

    if (resp.status === 404) {
      return null;
    }

    if (!resp.ok) {
      throw new Error(`Failed to fetch track overwrite: ${resp.statusText}`);
    }

    return (await resp.json()) as TrackOverwrite;
  } catch (error) {
    console.error('getTrackOverwrite error:', error);

    throw error;
  }
}

export async function getTrackOverwrites(
  isrcs: string[],
): Promise<TrackOverwriteRow[]> {
  try {
    const resp = await fetch(`${URL_PREFIX}/api/v1/overwrites/bulk`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ isrcs }),
    });

    if (!resp.ok) {
      throw new Error(`Failed to fetch track overwrites: ${resp.statusText}`);
    }

    return (await resp.json()) as TrackOverwriteRow[];
  } catch (error) {
    console.error('getTrackOverwrites error:', error);

    throw error;
  }
}

export async function upsertTrackOverwrite(
  data: TrackOverwritePost,
): Promise<void> {
  try {
    const resp = await fetch(`${URL_PREFIX}/api/v1/overwrites/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...data,
        track_title: data.track_title !== '' ? data.track_title : null,
        artist_name: data.artist_name !== '' ? data.artist_name : null,
      }),
    });

    if (!resp.ok) {
      throw new Error(`Failed to upsert track overwrite: ${resp.statusText}`);
    }
  } catch (error) {
    console.error('upsertTrackOverwrite error:', error);

    throw error;
  }
}

export async function deleteTrackOverwrite(isrc: string): Promise<void> {
  try {
    const resp = await fetch(`${URL_PREFIX}/api/v1/overwrites/${isrc}`, {
      method: 'DELETE',
    });

    if (!resp.ok) {
      throw new Error(`Failed to delete track overwrite: ${resp.statusText}`);
    }
  } catch (error) {
    console.error('deleteTrackOverwrite error:', error);

    throw error;
  }
}
